
const API = process.env.REACT_APP_API_KEY;

const fetchCityWeather = (city) => {
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API}&units=metric`;
    return (
        fetch(url)
        .then((response) => response.json())
        .then((data) => {
            if (data) {
            return {
                city: city,
                weatherData: data,
            };
            }
        })
        .catch((error) => {
            console.error(`Error Api ${city}:`, error);
            return null;
        })
    )
};
  
export { fetchCityWeather };